// Private lifecycle/configuration tables are refreshed through the authenticated
// inbox API. Adding them to this public channel rejects all its subscriptions.
export const subscribeInboxChanges = (client, name, handlers, onStatus) => {
    const channel = client.channel(name);
    [
        ['messaging', 'conversations', '*'],
        ['messaging', 'messages', 'INSERT'],
        ['messaging', 'integration_events', 'INSERT'],
        ['espuma', 'whatsapp_conversations_tramites', '*'],
        ['espuma', 'object_tags', '*'],
    ].forEach(([schema, table, event]) => {
        channel.on('postgres_changes', { event, schema, table }, handlers[table]);
    });
    channel.subscribe(onStatus);
    return channel;
};

export const mergeOpenedSession = (conversations, opened, result) => {
    const existing = conversations.find(c => c.conversation_id === opened.conversation_id);
    const updated = {
        ...opened,
        ...existing,
        ...result.conversation,
        conversation_id: opened.conversation_id,
        tramite_id: result.tramite_id,
        phone_number: result.conversation?.phone_number || existing?.phone_number || opened.phone_number,
    };
    return existing
        ? conversations.map(c => c.conversation_id === opened.conversation_id ? updated : c)
        : [updated, ...conversations];
};

// A fixed timer survives conversation updates, which can otherwise postpone
// recovery indefinitely. Returning to the tab also reconciles missed events.
export const startInboxRecovery = (refresh, intervalMs = 60000) => {
    const refreshVisible = () => {
        if (document.visibilityState !== 'hidden') refresh();
    };
    const interval = setInterval(refreshVisible, intervalMs);
    window.addEventListener('focus', refreshVisible);
    document.addEventListener('visibilitychange', refreshVisible);
    return () => {
        clearInterval(interval);
        window.removeEventListener('focus', refreshVisible);
        document.removeEventListener('visibilitychange', refreshVisible);
    };
};
